export default "__VITE_ASSET__upmY7Ut___"